
const digest = 'cb07115346e04cb20fd35fc8324036798cf8e86ce24d7b10beeb928540d58e1d';
const classes = {"removeItemWrapper":"_removeItemWrapper_1p3yu_1","warning":"_warning_1p3yu_5"};
const css = `._removeItemWrapper_1p3yu_1 {
  padding: 12px;
}

._warning_1p3yu_5 {
  color: #f00;
  margin-bottom: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  